export default {
  // Page title
  'smsReport.title': 'SMS Report',
  'smsReport.subtitle': 'SMS sending statistics and analysis report',

  // Form fields
  'smsReport.form.timeRange': 'Time Range',
  'smsReport.form.timeRangeRequired': 'Please select time range',
  'smsReport.form.startDate': 'Start Date',
  'smsReport.form.endDate': 'End Date',
  'smsReport.form.startTime': 'Start Time',
  'smsReport.form.startTimeRequired': 'Please select start time',
  'smsReport.form.startTimePlaceholder': 'Please select start time',
  'smsReport.form.endTime': 'End Time',
  'smsReport.form.endTimeRequired': 'Please select end time',
  'smsReport.form.endTimePlaceholder': 'Please select end time',
  'smsReport.form.taskName': 'Task',
  'smsReport.form.taskNamePlaceholder': 'Please enter task name',
  'smsReport.form.taskType': 'Type',
  'smsReport.form.taskTypePlaceholder': 'Please select type',
  'smsReport.form.groupBy': 'Group By',
  'smsReport.form.groupByTooltip': 'Select data grouping method',

  // Task types
  'smsReport.taskType.all': 'All Types',
  'smsReport.taskType.bulk': 'Bulk Send',
  'smsReport.taskType.automation': 'Automation',
  'smsReport.taskType.ndc': 'No Deposit',
  'smsReport.taskType.inactive': 'Inactive Users',
  'smsReport.taskType.churn': 'Churned Users',
  'smsReport.taskType.vip': 'VIP Tasks',
  'smsReport.taskType.welcome': 'Welcome SMS',
  'smsReport.taskType.restorage': 'Re-deposit after First Deposit',
  'smsReport.taskType.birthday': 'Birthday Reminder',
  'smsReport.taskType.unknown': 'Unknown',

  // Group options
  'smsReport.groupBy.day': 'Group by Day',
  'smsReport.groupBy.month': 'Group by Month',
  'smsReport.groupBy.task': 'Group by Task',

  // Buttons
  'smsReport.button.search': 'Search',
  'smsReport.button.reset': 'Reset',
  'smsReport.button.export': 'Export Report',

  // Statistics cards
  'smsReport.stats.totalSend': 'Total Sent',
  'smsReport.stats.successSend': 'Successful',
  'smsReport.stats.failSend': 'Failed',
  'smsReport.stats.avgSuccessRate': 'Avg Success Rate',
  'smsReport.stats.totalCost': 'Total Cost',

  // Table columns
  'smsReport.table.task': 'Task',
  'smsReport.table.type': 'Type',
  'smsReport.table.taskName': 'Task Name',
  'smsReport.table.taskType': 'Task Type',
  'smsReport.table.sendCount': 'Send Count',
  'smsReport.table.successCount': 'Success Count',
  'smsReport.table.failCount': 'Fail Count',
  'smsReport.table.successRate': 'Success Rate',
  'smsReport.table.cost': 'Cost',
  'smsReport.table.date': 'Date',
  'smsReport.table.actions': 'Actions',
  'smsReport.table.viewLogs': 'View Logs',

  // Log modal
  'smsReport.logs.title': 'SMS Logs',
  'smsReport.logs.time': 'Time',
  'smsReport.logs.task': 'Task',
  'smsReport.logs.user': 'User',
  'smsReport.logs.phone': 'Phone',
  'smsReport.logs.channel': 'Channel',
  'smsReport.logs.status': 'Status',
  'smsReport.logs.receipt': 'Receipt',
  'smsReport.logs.statusPending': 'Pending',
  'smsReport.logs.statusSuccess': 'Success',
  'smsReport.logs.statusFailed': 'Failed',

  // Messages
  'smsReport.message.selectTimeRange': 'Please select time range',
  'smsReport.message.exportSuccess': 'Export successful',
  'smsReport.message.exportFailed': 'Export failed',
  'smsReport.message.exporting': 'Exporting data...',
  'smsReport.message.queryFailed': 'Query failed',
  'smsReport.message.noData': 'No data available',

  // Hints
  'smsReport.hint.selectQuery': 'Please select query conditions and click search',
  'smsReport.hint.exportNote': 'Export function will generate Excel format report',
  'smsReport.hint.timeRangeLimit': 'Time range cannot exceed 90 days',

  // Status labels
  'smsReport.status.high': 'High',
  'smsReport.status.medium': 'Medium',
  'smsReport.status.low': 'Low',

  // Currency units
  'smsReport.currency.usd': 'USD',
  'smsReport.currency.cny': 'CNY',
  'smsReport.currency.php': 'PHP',
  'smsReport.currency.vnd': 'VND',

  // Pagination
  'smsReport.pagination.total': 'Total {{total}} records'
};
